import React from 'react';
import { compose } from 'js/utils/ramda.util';
import { ChangeForm } from 'js/components/common/ChangeForm';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { DYNAMIC_CHANGE_PIN, DEFAULT_FORM_NAME } from './constants';

export const DynamicChangePinBare = () => {
    const translate = useComponentTranslations();
    const changePin = hooks.useChangePin();
    const { formName } = useComponentConfig();

    return (
        <ChangeForm
            onSubmit={changePin}
            translate={translate}
            formName={formName || DEFAULT_FORM_NAME}
        />
    );
};

export const DynamicChangePin = compose(
    withComponent({
        isForLoggedIn: true,
        tkPrefix: 'playtech.mobile.system.dynamic-change-pin.'
    })
)(DynamicChangePinBare);

componentService.registerPageComponents({ [DYNAMIC_CHANGE_PIN]: DynamicChangePin });
